/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Unsupported_File_Type_ToastInputs */



/**
* | output |
* | --- |
* | "Unsupported file type. Please try importing a different file." |
*
* @param {Editor_Unsupported_File_Type_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_unsupported_file_type_toast = /** @type {((inputs?: Editor_Unsupported_File_Type_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Unsupported_File_Type_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type de fichier non pris en charge. Veuillez importer un fichier different.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht unterstützter Dateityp. Bitte versuchen Sie, eine andere Datei zu importieren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo di file non supportato. Prova a importare un file diverso.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неподдерживаемый тип файла. Пожалуйста, попробуйте импортировать другой файл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo de archivo no compatible. Intente importar un archivo diferente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件类型不支持。请尝试导入其他文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サポートされていないファイル形式です。別のファイルをインポートしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह फ़ाइल प्रकार समर्थित नहीं है। कृपया कोई भिन्न फ़ाइल आयात करने का प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo de arquivo não suportado. Tente importar um arquivo diferente.")
	return /** @type {LocalizedString} */ ("Unsupported file type. Please try importing a different file.")
});